export const selectOutputInput = (s, path) => s.outputMapping?.outputs?.[path]?.input ?? 'output'

export const selectOutputBlack = (s, path) => !!s.outputMapping?.outputs?.[path]?.black

export const selectProjectionMap = s => !!s.outputMapping?.active

export const selectMappingHover = s => s.outputMapping?.hover ?? null

export const selectMappingPreview = s => !!s.outputMapping?.preview

export const selectEdgePick = s => s.outputMapping?.edge_pick ?? null
